import React, { useState } from "react"
import { Link } from "gatsby"
import DesktopOnboardingForm from "./onboarding-form"
import * as styles from "./desktop.module.less"

const DesktopOnboarding = ({ title = "Rethink your space" }) => {
  const [category, setCategory] = useState(1)
  return (
    <div className={`${styles.desktop_onboarding} d-none d-xl-block`}>
      <div>
        <h1>{title}</h1>
        <Headings category={category} setCategory={setCategory} />
        <DesktopOnboardingForm category={category} desktop />
        <Message category={category} />
      </div>
    </div>
  )
}

export default DesktopOnboarding

const Message = ({ category = 1 }) => {
  return (
    <p className={styles.hero_text}>
      {category === 1
        ? `Your own dedicated office space for teams of 1-100.`
        : `Flexible, private offices on a pay-as-you-need basis.`}
    </p>
  )
}

const Headings = ({ category, setCategory = () => null }) => {
  return (
    <ul className={styles.headings}>
      <li>
        <button
          className={`btn ${category === 1 ? styles.header_active : ""}`}
          onClick={() => setCategory(1)}
        >
          Monthly Office Space
        </button>
      </li>
      <li>
        {process.env.GATSBY_TEMPORARY_NOT_AVAILABLE ? (
          <Link
            to={`/${process.env.GATSBY_TEMPORARY_NOT_AVAILABLE}`}
            className={`btn`}
          >
            On-demand Offices
          </Link>
        ) : (
          <>
            {/*// <button*/}
            {/*  //   className={`btn ${category === 2 ? styles.header_active : ""}`}*/}
            {/*  //   onClick={() => setCategory(2)}*/}
            {/*  // >*/}
            {/*  //   On-demand offices*/}
            {/*  // </button>*/}
            <Link to={"/on-demand-offices"} className={`btn`}>
              On-demand offices
            </Link>
          </>
        )}
      </li>
      <li>
        <Link to={"/meeting-rooms"} className={`btn`}>
          Meeting Rooms
        </Link>
      </li>
    </ul>
  )
}
